export default __webpack_public_path__ + "static/media/Knife of Dessication.58f738a5.jpg";